import _classCallCheck from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/soroban-rpc-api/soroban-rpc-api/build/docs/gatsby/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as dom from './dom.js';
import * as platform from '../common/platform.js';
import { IframeUtils } from './iframe.js';
import { StandardMouseEvent } from './mouseEvent.js';
import { DisposableStore } from '../common/lifecycle.js';
import { BrowserFeatures } from './canIUse.js';
export function standardMouseMoveMerger(lastEvent, currentEvent) {
  var ev = new StandardMouseEvent(currentEvent);
  ev.preventDefault();
  return {
    leftButton: ev.leftButton,
    buttons: ev.buttons,
    posx: ev.posx,
    posy: ev.posy
  };
}
export var GlobalMouseMoveMonitor = /*#__PURE__*/function () {
  function GlobalMouseMoveMonitor() {
    _classCallCheck(this, GlobalMouseMoveMonitor);

    this._hooks = new DisposableStore();
    this._mouseMoveEventMerger = null;
    this._mouseMoveCallback = null;
    this._onStopCallback = null;
  }

  _createClass(GlobalMouseMoveMonitor, [{
    key: "dispose",
    value: function dispose() {
      this.stopMonitoring(false);

      this._hooks.dispose();
    }
  }, {
    key: "stopMonitoring",
    value: function stopMonitoring(invokeStopCallback) {
      if (!this.isMonitoring()) {
        // Not monitoring
        return;
      } // Unhook


      this._hooks.clear();

      this._mouseMoveEventMerger = null;
      this._mouseMoveCallback = null;
      var onStopCallback = this._onStopCallback;
      this._onStopCallback = null;

      if (invokeStopCallback && onStopCallback) {
        onStopCallback();
      }
    }
  }, {
    key: "isMonitoring",
    value: function isMonitoring() {
      return !!this._mouseMoveEventMerger;
    }
  }, {
    key: "startMonitoring",
    value: function startMonitoring(initialElement, initialButtons, mouseMoveEventMerger, mouseMoveCallback, onStopCallback) {
      var _this = this;

      if (this.isMonitoring()) {
        // I am already hooked
        return;
      }

      this._mouseMoveEventMerger = mouseMoveEventMerger;
      this._mouseMoveCallback = mouseMoveCallback;
      this._onStopCallback = onStopCallback;
      var windowChain = IframeUtils.getSameOriginWindowChain();
      var mouseMove = platform.isIOS && BrowserFeatures.pointerEvents ? 'pointermove' : 'mousemove';
      var mouseUp = platform.isIOS && BrowserFeatures.pointerEvents ? 'pointerup' : 'mouseup';
      var listenTo = windowChain.map(function (element) {
        return element.window.document;
      });
      var shadowRoot = dom.getShadowRoot(initialElement);

      if (shadowRoot) {
        listenTo.unshift(shadowRoot);
      }

      var _iterator = _createForOfIteratorHelper(listenTo),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var element = _step.value;

          this._hooks.add(dom.addDisposableThrottledListener(element, mouseMove, function (data) {
            if (data.buttons !== initialButtons) {
              // Buttons state has changed in the meantime
              _this.stopMonitoring(true);

              return;
            }

            _this._mouseMoveCallback(data);
          }, function (lastEvent, currentEvent) {
            return _this._mouseMoveEventMerger(lastEvent, currentEvent);
          }));

          this._hooks.add(dom.addDisposableListener(element, mouseUp, function (e) {
            return _this.stopMonitoring(true);
          }));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      if (IframeUtils.hasDifferentOriginAncestor()) {
        var lastSameOriginAncestor = windowChain[windowChain.length - 1]; // We might miss a mouse up if it happens outside the iframe
        // This one is for Chrome

        this._hooks.add(dom.addDisposableListener(lastSameOriginAncestor.window.document, 'mouseout', function (browserEvent) {
          var e = new StandardMouseEvent(browserEvent);

          if (e.target.tagName.toLowerCase() === 'html') {
            _this.stopMonitoring(true);
          }
        })); // This one is for FF


        this._hooks.add(dom.addDisposableListener(lastSameOriginAncestor.window.document, 'mouseover', function (browserEvent) {
          var e = new StandardMouseEvent(browserEvent);

          if (e.target.tagName.toLowerCase() === 'html') {
            _this.stopMonitoring(true);
          }
        })); // This one is for IE


        this._hooks.add(dom.addDisposableListener(lastSameOriginAncestor.window.document.body, 'mouseleave', function (browserEvent) {
          _this.stopMonitoring(true);
        }));
      }
    }
  }]);

  return GlobalMouseMoveMonitor;
}();